const GRAPH_BASE = "https://graph.microsoft.com/beta";
export class GraphError extends Error {
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = "GraphError";
    }
}
async function handleResponse(response) {
    if (!response.ok) {
        let errorMessage = `Erreur API Graph (${response.status})`;
        try {
            const body = await response.json();
            if (body?.error?.message)
                errorMessage = body.error.message;
        }
        catch { /* ignore */ }
        throw new GraphError(response.status, errorMessage);
    }
    return response.json();
}
export async function graphGet(path, accessToken) {
    const response = await fetch(`${GRAPH_BASE}${path}`, {
        headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" },
    });
    return handleResponse(response);
}
export async function graphPost(path, body, accessToken) {
    const response = await fetch(`${GRAPH_BASE}${path}`, {
        method: "POST",
        headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    return handleResponse(response);
}
export async function graphPatch(path, body, accessToken) {
    const response = await fetch(`${GRAPH_BASE}${path}`, {
        method: "PATCH",
        headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    return handleResponse(response);
}
export async function graphUpload(path, file, contentType, accessToken) {
    const response = await fetch(`${GRAPH_BASE}${path}`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": contentType },
        body: file,
    });
    return handleResponse(response);
}
export async function graphDelete(path, accessToken) {
    const response = await fetch(`${GRAPH_BASE}${path}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) {
        throw new GraphError(response.status, `Erreur suppression (${response.status})`);
    }
}
